module.exports = {
          srcSet: __webpack_public_path__ + "e266e0cb4fa2a97883873d8c4e9662f7-180.png"+" 180w",
          images:[ {path: __webpack_public_path__ + "e266e0cb4fa2a97883873d8c4e9662f7-180.png",width: 180,height: 106}],
          src: __webpack_public_path__ + "e266e0cb4fa2a97883873d8c4e9662f7-180.png",
          toString:function(){return __webpack_public_path__ + "e266e0cb4fa2a97883873d8c4e9662f7-180.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAYElEQVR4nI3NOwqDUBBG4c9nlUrETmyzBJdgZZ3SykLSZAFKlh4u3BSKggd+ZgbOzLAnibmkOMzpmdRjxoQXRgxo8UD2P/TBFyve2LDgGeUOTRCruBnehb5GjjLWkPv8ALBzBbsPJbrcAAAAAElFTkSuQmCC",
          width: 180,
          height: 106
        }